"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Star;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Star(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Associations"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "star"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M25.279,90.542a2.5,2.5,0,0,1-2.464-2.923l4.5-26.231L8.255,42.81a2.5,2.5,0,0,1,1.386-4.264l26.338-3.828L47.758,10.852a2.5,2.5,0,0,1,4.485,0L64.021,34.718,90.36,38.546a2.5,2.5,0,0,1,1.385,4.264L72.687,61.388l4.5,26.231a2.5,2.5,0,0,1-3.627,2.636L50,77.87,26.442,90.255A2.5,2.5,0,0,1,25.279,90.542ZM15.372,42.765l16.373,15.96a2.5,2.5,0,0,1,.719,2.212L28.6,83.472,48.837,72.833a2.5,2.5,0,0,1,2.326,0L71.4,83.472,67.536,60.937a2.5,2.5,0,0,1,.719-2.212l16.373-15.96L62,39.477a2.5,2.5,0,0,1-1.883-1.368L50,17.606l-10.119,20.5A2.5,2.5,0,0,1,38,39.477Z"
  }))));
}